"use strict";
exports.__esModule = true;
exports.PageType = void 0;
var PageType;
(function (PageType) {
    PageType["ARTICLE"] = "article";
    PageType["BRANCH_ACTIVITIES"] = "branch_activities";
    PageType["COLD_ARTICLE"] = "cold_article";
    PageType["CONTACT_PAGE"] = "contact_page";
    PageType["FINANCIAL_DEBT"] = "financial_debt";
    PageType["FINANCIAL_KEY_FIGURES"] = "financial_key_figures";
    PageType["FINANCIAL_PRESS_RELEASE"] = "financial_press_release";
    PageType["FINANCIAL_PUBLICATION"] = "financial_publication";
    PageType["FINANCIAL_RATING"] = "financial_rating";
    PageType["GOUVERNANCE"] = "gouvernance";
    PageType["HOME"] = "home";
    PageType["HUB_ACTUS"] = "hub_actus";
    PageType["HUB_NEWSROOM"] = "hub_newsroom";
    PageType["HOT_ARTICLE"] = "hot_article";
    PageType["LA_POSTE_EN_4"] = "la_poste_en_4";
    PageType["MEDIA_PRESS"] = "media_presse";
    PageType["MEDIA_PRESS_RELEASE"] = "media_presse_release";
    PageType["NEWSROOM"] = "newsroom";
    PageType["POSTMEN"] = "postmen";
    PageType["PUBLIC_SERVICE_MISSIONS"] = "public_service_missions";
    PageType["SEARCH_PAGE"] = "search_page";
})(PageType = exports.PageType || (exports.PageType = {}));
//# sourceMappingURL=page-type.js.map